module.exports = {

    methods: {

        loadInitialStateFromLocalStorage() {
            let state = Storage.get(this.initialStateKey)
            if (state) {
                this.initialUiState[this.index] = JSON.parse(state)
            }
        },

        onStateChanged(event) {
            if (event.uiState.hasOwnProperty(this.index)) {
                Storage.set(this.initialStateKey, JSON.stringify(event.uiState[this.index]))
            }
            event.setUiState(event.uiState)
        },
    }
}
